@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}
@if (viewModel) {
    <div>
        @if (currentYear) {
            <add-filing-modal #AddFilingModal
                              [annualYearID]="currentYear.annualYearID"
                              [filingTypes]="filingTypes"
                              [isMergedParcel]="isMergedParcel"
                              (add)="addFiling($event)">
            </add-filing-modal>
        }
        @if (viewModel.model.length === 0) {
            <div class="text-center">
                <div class="lead">
                    There are presently no compliance filings for {{ currentYear.annualYear1 }}.
                </div>
                @if (editState.hasWritePermission) {
                    <button class="ace-btn btn-primary" (click)="openAddFiling()">New Compliance Filing</button>
                }
            </div>
        }
        @if (viewModel.showTabs && editState.editMode) {
            <button type="button" (click)="openAddFiling()" style="float:right;margin-top:0.5em;" class="ace-btn btn-sm btn-primary">
                New Compliance Filing
            </button>
        }
        @if (viewModel.model.length > 0 && viewModel.showTabs) {
            <tabset #filingTabs>
                @for (filing of viewModel.model; track filing; let i = $index; let last = $last) {
                    <tab [active]="i === viewModel.currentFilingIndex"
                         (selectTab)="switchTabs(i)">
                        <ng-template tabHeading>
              <span helpTooltip
                    helpContentId="annual-details.phantom-filing"
                    position="top"
                    [helpDisabled]="!filing.isFromConsolidatedParcel">
                @if (filing.isFromConsolidatedParcel) {
                    <i class="year-linked fa fa-chain"></i>
                }
                  @if (filing.filingBatchId) {
                      <i title="Filing batch" class="fa fa-files-o"></i>
                  } {{ getFilingHeading(filing) }}
                </span>
                        </ng-template>
                        <ng-container [ngTemplateOutlet]="filingTemplate" [ngTemplateOutletContext]="{ $implicit: filing }"></ng-container>
                    </tab>
                }
            </tabset>
        }
        @if (viewModel.currentFiling && !viewModel.showTabs) {
            <ng-container
                [ngTemplateOutlet]="filingTemplate"
                [ngTemplateOutletContext]="{ $implicit: viewModel.currentFiling }">
            </ng-container>
        }
    </div>
}

<ng-template #filingTemplate let-filing>
    @if (isLoading) {
        <div class="text-center" style="margin-top: 50px;">
            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
        </div>
    }

    @if (!isLoading) {
        <div>
            <div class="float-end">
                @if (filing.hasInProgressIntakeItems && !isDocumentProcessing) {
                    <entity-in-progress-indicator [entityId]="filing.filingId" [entityTypeId]="filingEntityTypeId" [isDocumentProcessing]="isDocumentProcessing"></entity-in-progress-indicator>
                }
                <entity-attachments [(hasAttachments)]="filing.hasAttachments"
                                    buttonClass="has-icon"
                                    [modalData]="viewModel.attachmentModalData">
                </entity-attachments>
                <entity-comments [(hasComments)]="filing.hasComments"
                                 buttonClass="has-icon"
                                 [modalData]="viewModel.commentModalData">
                </entity-comments>
            </div>
            <table class="annual-appeal" (change)="setDirty()">
                <tr>
                    <td>Filing Type:</td>
                    <td>
                        <span>{{ filing.filingType.name }}</span>
                    </td>
                </tr>
                <tr>
                    <td>Description:</td>
                    <td>
                        @if ((!editState.editMode) || filing.isFromConsolidatedParcel) {
                            <span>{{ filing.description }}</span>
                        }
                        @if (editState.editMode && !filing.isFromConsolidatedParcel) {
                            <input type="text" class="form-control" [(ngModel)]="filing.description" maxlength="15">
                        }
                    </td>
                </tr>
                <tr class="filing-due-date">
                    <td>Due Date:</td>
                    <td [ngClass]="{'overridden-due-date': dueDateOverridden(filing)}" style="position: relative;">
                        <weissman-datetime [(inputDate)]="filing.dueDate"
                                           [readOnly]="(!editState.editMode) || filing.isFromConsolidatedParcel || filing.filingBatchId"
                                           [dateOnly]="true"
                                           (validationChange)="onDueDateValidationChange($event)"
                                           (change)="onTaskRelevantFieldChanged()"
                                           [required]="true"
                                           (inputDateBlur)="revertDateCheck(filing)"
                                           #dueDate>
                        </weissman-datetime>
                        @if (editState.hasWritePermission && editState.editMode && (!filing.isFromConsolidatedParcel) && dueDateOverridden(filing)) {
                            <button class="ace-btn has-icon btn-primary btn-danger"
                                    style="margin: 0; position: absolute; right: -31px; top: 4px;"
                                    (click)="resetDueDate(filing)">
                                <i class="fa fa-undo"></i>
                            </button>
                        }
                    </td>
                </tr>
                @if (filing.filingBatch) {
                    <tr>
                        <td>Batch Due Date:</td>
                        <td style="position: relative;">
                            <span>{{ filing.filingBatch.dueDate | weissmanDateFormat: true }}</span>
                        </td>
                    </tr>
                }
                @if (filing.isFromConsolidatedParcel) {
                    <tr>
                        <td>Reported Cost (Merged):</td>
                        <td>
                            <span>${{ (filing.mergedReportedCost || 0) |  number: '1.0-0' }}</span>
                        </td>
                    </tr>
                }
                @if (filing.isFromConsolidatedParcel) {
                    <tr>
                        <td>Filed Value (Merged):</td>
                        <td>
                            <span>${{ (filing.mergedReportedValue || 0) |  number: '1.0-0' }}</span>
                        </td>
                    </tr>
                }
                @if (!filing.isFromConsolidatedParcel) {
                    <tr>
                        <td>Reported Cost:</td>
                        <td>
                            @if ((!editState.editMode) || filing.filingBatchId) {
                                <span>${{ (filing.reportedCost || 0) | number: '1.0-0' }}</span>
                            }
                            @if (editState.editMode && !filing.filingBatchId) {
                                <input type="text"
                                       class="form-control input-number"
                                       [(ngModel)]="filing.reportedCost"
                                       (ngModelChange)="setDirty()"
                                       currencyMask
                                       [options]="{ allowNegative: false, precision: 0, prefix: '' }"/>
                            }
                        </td>
                    </tr>
                }
                @if (!filing.isFromConsolidatedParcel) {
                    <tr>
                        <td>Filed Value:</td>
                        <td>
                            @if ((!editState.editMode) || filing.filingBatchId) {
                                <span>${{ (filing.value || 0) | number: '1.0-0' }}</span>
                            }
                            @if (editState.editMode && !filing.filingBatchId) {
                                <input type="text"
                                       class="form-control input-number"
                                       [(ngModel)]="filing.value"
                                       (ngModelChange)="setDirty()"
                                       currencyMask
                                       [options]="{ allowNegative: false, precision: 0, prefix: '' }"/>
                            }
                        </td>
                    </tr>
                }
                <tr>
                    <td>Status:</td>
                    <td>
                        @if (viewModel.currentTaskSummary) {
                            <div style="font-size: 14px;">
                                <i class="fa fa-check" [hidden]="!viewModel.currentTaskSummary.SeriesIsComplete"
                                   style="color: green; float: left; font-size: 16px;"></i>
                                <span class="anchor-style" (click)="launchTaskModal(filing)"
                                      tooltip="{{ this.editState.validationMessage }}" placement="left"
                                      triggers="click focus" #filingTaskValidation="bs-tooltip">
                    {{ viewModel.currentTaskSummary.Status }}
                                    @if (viewModel.currentTaskSummary.CompletedDateTime) {
                                        <span>
                        {{ viewModel.currentTaskSummary.CompletedDateTime | weissmanDateFormat: true: "Central" }}
                      </span>
                                    }
                  </span>
                            </div>
                        }
                        @if (!viewModel.currentTaskSummary) {
                            <div style="font-size: 14px;">
                                N/A - No Responsibility
                            </div>
                        }
                    </td>
                </tr>
                @if (filing.isFromConsolidatedParcel) {
                    <tr>
                        <td>Consolidated Filing:</td>
                        <td>
                            <span class="ace-btn btn-link pointer" (click)="goToFiling(filing)">{{ getFilingHeading(filing) }}</span>
                        </td>
                    </tr>
                }
            </table>
            <div>
                @if ((!hideDelete) && editState.editMode && (!filing.filingBatchId) && (!filing.isFromConsolidatedParcel)) {
                    <button class="ace-btn btn-sm btn-primary btn-danger"
                            type="button"
                            (click)="deleteFiling(filing)">
                        Delete Filing
                    </button>
                }
                @if (canCreateFilingBatch) {
                    <button type="button"
                            class="ace-btn btn-sm btn-primary"
                            [disabled]="creatingFilingBatch"
                            (click)="createFilingBatch(filing)">
                        Begin Preparation
                    </button>
                }
                @if (filing.filingBatch && (!filing.isFromConsolidatedParcel)) {
                    <button type="button"
                            class="ace-btn btn-sm btn-primary"
                            (click)="goToReturnFilingBatch(filing)">
                        {{ getFilingBatchPrepareLabel(filing) }}
                    </button>
                }
            </div>
        </div>
    }
</ng-template>
